import { useTranslation } from 'react-i18next';

export default function Infographic() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t('infographic.title')}{' '}
            <span className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent">
              {t('infographic.titleHighlight')}
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            {t('infographic.subtitle')}
          </p>
        </div>

        {/* Infographic */}
        <div className="relative max-w-6xl mx-auto">
          {/* Main Container */}
          <div className="grid md:grid-cols-2 gap-8 relative">
            {/* AVANT - Left Side */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100">
              {/* Header */}
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-2xl mb-4">
                  <i className="ri-close-circle-line text-3xl text-gray-400"></i>
                </div>
                <h3
                  className="text-2xl font-bold text-gray-900 mb-2"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {t('infographic.beforeTitle')}
                </h3>
                <p className="text-sm text-gray-500">{t('infographic.beforeSubtitle')}</p>
              </div>

              {/* Image */}
              <div className="mb-8 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/d922528eff2fb423e32abbefe43f9957.jpg"
                  alt="Problèmes aéroportuaires"
                  className="w-full h-64 object-cover grayscale opacity-60"
                />
              </div>

              {/* Metrics */}
              <div className="space-y-4">
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-gray-500 text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric1Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-700"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric1Before')}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-emotion-sad-line text-gray-500 text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric2Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-700"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric2Before')}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-leaf-line text-gray-500 text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric3Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-700"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric3Before')}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-star-line text-gray-500 text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric4Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-700"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric4Before')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Central Arrow */}
            <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
              <div className="w-16 h-16 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] rounded-full flex items-center justify-center shadow-xl">
                <i className="ri-arrow-right-line text-white text-2xl"></i>
              </div>
            </div>

            {/* APRÈS - Right Side */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-[#C9A961]/20">
              {/* Header */}
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#4ECDC4]/10 to-[#44A08D]/10 rounded-2xl mb-4">
                  <i className="ri-checkbox-circle-line text-3xl text-[#4ECDC4]"></i>
                </div>
                <h3
                  className="text-2xl font-bold text-gray-900 mb-2"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {t('infographic.afterTitle')}
                </h3>
                <p className="text-sm text-gray-500">{t('infographic.afterSubtitle')}</p>
              </div>

              {/* Image */}
              <div className="mb-8 rounded-2xl overflow-hidden border-2 border-[#C9A961]/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20professional%20luggage%20repair%20workshop%20with%20skilled%20technician%20expertly%20fixing%20premium%20suitcase%20using%20specialized%20tools%2C%20bright%20clean%20workspace%20with%20organized%20equipment%2C%20warm%20ambient%20lighting%2C%20satisfied%20customer%20in%20background%2C%20high-tech%20repair%20station%2C%20professional%20service%20atmosphere%2C%20contemporary%20industrial%20design%20with%20teal%20and%20warm%20orange%20accent%20lighting&width=600&height=400&seq=infographic-after-v2&orientation=landscape"
                  alt="Atelier DFPRO"
                  className="w-full h-64 object-cover"
                />
              </div>

              {/* Metrics */}
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-[#4ECDC4]/5 to-[#44A08D]/5 rounded-xl p-4 border border-[#4ECDC4]/20">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-white text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric1Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-900"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric1After')}
                      </div>
                    </div>
                    <div className="px-3 py-1 bg-[#4ECDC4]/10 rounded-full">
                      <span className="text-xs font-semibold text-[#4ECDC4]">{t('infographic.metric1Improvement')}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#4ECDC4]/5 to-[#44A08D]/5 rounded-xl p-4 border border-[#4ECDC4]/20">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-emotion-happy-line text-white text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric2Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-900"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric2After')}
                      </div>
                    </div>
                    <div className="px-3 py-1 bg-[#4ECDC4]/10 rounded-full">
                      <span className="text-xs font-semibold text-[#4ECDC4]">{t('infographic.metric2Improvement')}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#4ECDC4]/5 to-[#44A08D]/5 rounded-xl p-4 border border-[#4ECDC4]/20">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-leaf-line text-white text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric3Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-900"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric3After')}
                      </div>
                    </div>
                    <div className="px-3 py-1 bg-[#4ECDC4]/10 rounded-full">
                      <span className="text-xs font-semibold text-[#4ECDC4]">{t('infographic.metric3Improvement')}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#4ECDC4]/5 to-[#44A08D]/5 rounded-xl p-4 border border-[#4ECDC4]/20">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-star-fill text-white text-lg"></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 mb-1">{t('infographic.metric4Label')}</div>
                      <div
                        className="text-xl font-bold text-gray-900"
                        style={{ fontFamily: 'Poppins, sans-serif' }}
                      >
                        {t('infographic.metric4After')}
                      </div>
                    </div>
                    <div className="px-3 py-1 bg-[#4ECDC4]/10 rounded-full">
                      <span className="text-xs font-semibold text-[#4ECDC4]">{t('infographic.metric4Improvement')}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Summary Bar */}
          <div className="mt-12 bg-gradient-to-r from-[#0A1F44] to-[#16213e] rounded-2xl p-8">
            <div className="grid md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  1h-2h
                </div>
                <div className="text-white/60 text-sm">{t('infographic.summaryLabel1')}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  -65%
                </div>
                <div className="text-white/60 text-sm">{t('infographic.summaryLabel2')}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  98%
                </div>
                <div className="text-white/60 text-sm">{t('infographic.summaryLabel3')}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  -80%
                </div>
                <div className="text-white/60 text-sm">{t('infographic.summaryLabel4')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
